export default __webpack_public_path__ + "images/HM.74e127c.png";